import { Box } from "@mui/material";
import { useState } from "react";

// call page
import { Navigate } from "react-router-dom";
import IssueIndent from "../features/stores/issues/IssueIndent.jsx";
import StoreManagementMenu from "../features/stores/Store-menu.jsx";
import StoreMaster from "../features/stores/master/StoreList.jsx";
import AddStoreLedger from "../features/stores/ledger/StoreLedger.jsx";
import MaterialMaster from "../features/stores/material/MaterialList.jsx";
import MaterialStockUpload from "../features/stores/stock/MaterialStockList.jsx";
import ApproveRequestIndent from "../features/purchase/request-indent/ApproveRequestIndent.jsx";
import PurchaseIndent from "../features/purchase/purchase-indent/PurchaseIndent.jsx";


const StoreManagement = () => {


    const [activePage, setActivePage] = useState('ViewMainPage');

    const SetActive = (page) => {
        setActivePage(page);
    }

    const handleBackWinderMachineEntry = () => {
        setActivePage('ViewMainPage');
    }
    const handleBackDashboard = () => {
        Navigate("/");
    }

    return (


        <Box position="relative">


            {activePage === "ViewMainPage" && (<StoreManagementMenu
                SetActive={SetActive} handleBackDashboard={handleBackDashboard}
            />)}

            {activePage === "ViewStore" && (
                <StoreMaster handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ViewMaterial" && (
                <MaterialMaster handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ApproveRequestIndent" && (
                <ApproveRequestIndent handleBackWinderMachineEntry={handleBackWinderMachineEntry} formMode={1} />
            )}

            {activePage === "IssueIndent" && (
                <IssueIndent handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "StoreLedger" && (
                <AddStoreLedger handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ViewMaterialStock" && (
                <MaterialStockUpload handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "PurchaseIndent" && (
                <PurchaseIndent handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}


        </Box>
    );
};
export default StoreManagement;